<template>
  <div class="row">
    <div v-if="driver" class="col-md-12">
      <div class="card">
        <h2 class="card-header">Driver overview</h2>
        <div class="card-body">
          <h5 class="card-title">{{ driver.name }}</h5>
          <h6 class="card-subtitle mb-4 text-muted">
            Driver ID:
            <code>{{ driver.id }}</code>
          </h6>

          <div class="row">
            <div class="col-md-6">
              <table class="table">
                <tbody>
                  <tr>
                    <th>Address</th>
                    <td>{{ driver.address }}</td>
                  </tr>
                  <tr>
                    <th>Postcode</th>
                    <td>{{ driver.postcode }}</td>
                  </tr>
                  <tr>
                    <th>Phone number</th>
                    <td>{{ driver.phoneNumber }}</td>
                  </tr>
                  <tr>
                    <th>Email address</th>
                    <td>{{ driver.emailAddress }}</td>
                  </tr>
                  <tr>
                    <th>Created</th>
                    <td>{{ driver.createdAt | moment('from', 'now') }}</td>
                  </tr>
                  <tr>
                    <th>Last updated</th>
                    <td>{{ driver.updatedAt | moment('from', 'now') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-6">
              <div class="mapcontainer" style="height:325px">
                <l-map ref="map" :zoom="addressMap.zoom" :center="addressMap.center">
                  <l-tile-layer :url="addressMap.url" :attribution="addressMap.attribution"></l-tile-layer>
                  <l-marker :lat-lng="addressMap.marker"></l-marker>
                </l-map>
              </div>
            </div>
          </div>
          <!-- {{ driver }} -->
        </div>
      </div>

      <driver-sales-list :driver-id="driverId"></driver-sales-list>
    </div>
    <div v-else>
      <div v-if="loading" class="spinner-container">
        <double-bounce size="60px"></double-bounce>
      </div>
    </div>
  </div>
</template>
  
<script>
import { DoubleBounce } from "vue-loading-spinner";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import DriverSalesList from "./DriverSalesList";

export default {
  name: "DriverPage",
  components: {
    DoubleBounce,
    LMap,
    LTileLayer,
    LMarker,
    DriverSalesList
  },
  data() {
    return {
      error: null,
      loading: null,
      driver: null,
      addressMap: {
        zoom: 13,
        center: L.latLng(47.41322, -1.219482),
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        marker: L.latLng(47.41322, -1.219482)
      }
    };
  },
  props: ["driverId"],
  beforeMount() {
    this.loading = true;
    this.axios
      .get(`/v1/drivers/${this.driverId}?_embed=terminals`)
      .then(response => {
        this.loading = false;
        this.driver = response.data;
        const latLng = L.latLng(
          response.data.addressCoordinates.latitude,
          response.data.addressCoordinates.longitude
        );
        this.addressMap.center = latLng;
        this.addressMap.marker = latLng;
        this.$nextTick(function() {
          this.$refs.map.mapObject.invalidateSize();
        });
      })
      .catch(error => {
        this.loading = false;
        this.error = "Failed to load driver";
      });
  }
};
</script>
